import './_product-card-button.scss';

export default () => {};
